import { Button, Grid, IconButton } from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import ConfirmDeleteModal from "components/ConfirmDeleteModal";
import GKClientDataGrid from "components/GKClientDataGrid";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import { useState } from "react";
import { MdDelete } from "react-icons/md";
import axiosInstance from "utils/axiosInstance";
import { QueryKeys } from "utils/queryKey";
import CreateFaq from "./CreateFaq";
import CreateModule from "./CreateModule";

const Faq = () => {
  const [openCreateModule, setOpenCreateModule] = useState(false);

  const [openCreateCard, setOpenCreateCard] = useState(false);

  const [moduleData, setModuleData] = useState({});

  const [cardData, setCardData] = useState({});

  const [confirmationModal, setConfirmationModal] = useState(false);

  const [brokerTempleId, setBrokerTempleId] = useState(0);

  const { data, refetch, isFetching } = useQuery({
    queryKey: [QueryKeys.BROKER_MASTER_DETAILS_LIST],
    queryFn: () => axiosInstance.get(`/faq/`),
    onError: () => {},
  });

  const { mutate: handleDeleteCardDetails } = useMutation({
    mutationKey: ["DELETE_FAQ"],
    mutationFn: () => axiosInstance.delete(`/faq/${brokerTempleId}/`),
    onSuccess: () => {
      refetch();
    },
    onError: () => {},
  });

  const columns = [
    {
      headerName: "description",
      field: "description",
      flex: 1,
      minWidth: 100,
      disableColumnMenu: true,
    },

    {
      headerName: "moduleName",
      field: "moduleName",
      flex: 1,
      minWidth: 100,
      disableColumnMenu: true,
    },
    {
      headerName: "question",
      field: "question",
      flex: 1,
      minWidth: 100,
      disableColumnMenu: true,
    },

    {
      headerName: "Actions",
      disableColumnMenu: true,
      headerAlign: "right",
      align: "right",
      flex: 1,
      minWidth: 80,
      field: "action",
      type: "action",
      renderCell: (item) => (
        <Grid container gap={1} justifyContent={"flex-end"}>
          <IconButton
            color="error"
            onClick={(event) => {
              event.stopPropagation();
              setBrokerTempleId(item.id);
              setCardData({});
              setConfirmationModal(true);
            }}
          >
            <MdDelete size={20} />
          </IconButton>
        </Grid>
      ),
    },
  ];
  return (
    <DashboardLayout
      title="FAQ"
      breadcrumbs={[
        {
          name: "FAQ",
          path: "/app/Card",
        },
      ]}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <GKClientDataGrid
            loading={isFetching}
            columns={columns}
            rows={data?.data?.data || []}
            onRowClick={(row) => {
              setCardData(row.row);
              setOpenCreateCard(true);
            }}
            headerComponent={
              <Grid container item xs={12} gap={1} justifyContent="flex-end">
                <Button
                  sx={{
                    fontSize: "0.7rem",
                    fontFamily: '"Arial", sans-serif',
                    textTransform: "none",
                  }}
                  onClick={() => {
                    setModuleData({});
                    setOpenCreateModule(true);
                  }}
                  variant="contained"
                >
                  Create Module
                </Button>
                <Button
                  sx={{
                    fontSize: "0.7rem",
                    fontFamily: '"Arial", sans-serif',
                    textTransform: "none",
                  }}
                  onClick={() => {
                    setCardData({});
                    setOpenCreateCard(true);
                  }}
                  variant="contained"
                >
                  Create FAQ
                </Button>
              </Grid>
            }
          />
        </Grid>
      </Grid>
      {openCreateModule && (
        <CreateModule
          inModuleOpen={openCreateModule}
          setIsModuleOpen={setOpenCreateModule}
          refetch={refetch}
          moduleData={moduleData}
        />
      )}

      {confirmationModal && (
        <ConfirmDeleteModal
          open={confirmationModal}
          setOpen={setConfirmationModal}
          onDelete={() => handleDeleteCardDetails()}
          refetch={refetch}
          title={"Faq"}
          isDelete
        />
      )}

      {openCreateCard && (
        <CreateFaq
          inCardOpen={openCreateCard}
          setIsCardOpen={setOpenCreateCard}
          refetch={refetch}
          cardData={cardData}
        />
      )}
    </DashboardLayout>
  );
};

export default Faq;
